import { db } from "../firebase";
import { ref, get } from "firebase/database";

/**
 * Check if viewerUid can see ownerUid's profile photo.
 * ownerProfile: { photoURL, photoPrivacy? }
 * ownerUid: the profile owner's UID
 * viewerUid: the person trying to see the photo (null = not logged in)
 */
export async function canSeePhoto(ownerUid, ownerProfile, viewerUid) {
  if (!ownerProfile?.photoURL) return false;
  if (viewerUid === ownerUid) return true; // always see own photo
  const privacy = ownerProfile.photoPrivacy || "everyone";
  if (privacy === "everyone") return true;
  if (privacy === "nobody") return false;
  if (!viewerUid) return false; // not logged in, can't pass contacts/custom check
  if (privacy === "contacts") {
    try {
      const snap = await get(ref(db, `contacts/${ownerUid}/${viewerUid}`));
      return snap.exists();
    } catch { return false; }
  }
  if (privacy === "custom") {
    try {
      const snap = await get(ref(db, `users/${ownerUid}/photoAllowList/${viewerUid}`));
      return snap.exists();
    } catch { return false; }
  }
  return true;
}
